var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit_-_Default",
    "data-name": "Edit - Default",
    d: "M4.5,14.788V17.5H7.208L15.195,9.51,12.487,6.8ZM17.289,7.415a.719.719,0,0,0,0-1.018L15.6,4.707a.719.719,0,0,0-1.018,0L13.259,6.029l2.708,2.708Z",
    transform: "translate(-4.5 -4.496)",
    fill: "#b9b9b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDefault);
export default __webpack_public_path__ + "static/media/Edit - Default.46baa90e1711063e3ea553943580a2f9.svg";
export { ForwardRef as ReactComponent };